import { formatPrice } from '@/app/components/search/utils/formatting.ts';
import type { Localization } from '@/app/components/search/common/Localization';

export const getPriceIncrementLabel = ({
  priceIncrement,
  localization,
}: {
  priceIncrement: number;
  localization: Localization;
}) => `${priceIncrement < 0 ? '-' : '+'} ${formatPrice({ price: Math.abs(priceIncrement), localization })}`;
